const type = 'advanced'
const path = '/advance/angular-python/'
const name = 'server.py'

const conditions = [
  {
    option: 'frontend',
    value: 'angular',
  },
]

export { type, path, name, conditions }
